import React from "react";
import AccordionComp from "../Components/AccordionComp";
import PlayersInGame from "./PlayersInGame";

interface PlayersInGameAccordionProps {
  currentPlayers: Record<string, boolean>;
  playerlist: Record<string, any>;
}

const PlayersInGameAccordion: React.FC<PlayersInGameAccordionProps> = ({
  currentPlayers,
  playerlist,
}) => {
  return (
    <AccordionComp title="Players In Game" list={currentPlayers}>
      <PlayersInGame currentPlayers={currentPlayers} playerlist={playerlist} />
    </AccordionComp>
  );
};

export default PlayersInGameAccordion;
